module.exports = __webpack_public_path__ + "img/banner_coun_02.6c8e7647.png";